"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
/*!
 * Copyright (c) 2015-2023 Cisco Systems, Inc. See LICENSE file.
 */
var WebinarCollection = /*#__PURE__*/function () {
  function WebinarCollection() {
    (0, _classCallCheck2.default)(this, WebinarCollection);
    (0, _defineProperty2.default)(this, "webinarInfo", void 0);
    (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
    (0, _defineProperty2.default)(this, "mainIndex", 'sessionId');
    this.webinarInfo = {};
  }
  (0, _createClass2.default)(WebinarCollection, [{
    key: "set",
    value: function set(id, info) {
      this.webinarInfo[id] = info;
    }

    /**
     * @param {String} id
     * @returns {Member}
     */
  }, {
    key: "get",
    value: function get(id) {
      return this.webinarInfo[id];
    }
  }]);
  return WebinarCollection;
}();
var _default = exports.default = WebinarCollection;
//# sourceMappingURL=collection.js.map
